import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { ToastComponent } from './toast.component';

@Component({
    selector: 'app-toast-container',
    imports: [ToastComponent],
    templateUrl: './toast-container.component.html',
    styleUrl: './toast-container.component.scss'
})
export class ToastContainerComponent {
    protected readonly toastService = inject(ToastService);

    /**
     * Handle toast close button click
     */
    protected closeToast(id: string): void {
        this.toastService.dismiss(id);
    }

    /**
     * Check if toast is exiting
     */
    protected isExiting(id: string): boolean {
        return this.toastService.isExiting(id);
    }
}
